var path = 'app/components/stavkaNaloga/materijal.html';
var html = "<h2>Materijal</h2><hr><div class=\"row\"><div class=\"col-lg-12\"><button ng-repeat=\"item in vm.items track by $index\" ng-click=\"vm.click(item)\" class=\"btn btn-primary margin-right10 margin-bottom20\" ng-class=\"{'btn-warning': vm.itemSelected(item)}\" type=\"button\"><i class=\"fa fa-recycle\"></i><br>{{item.naziv}}</button></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/stavkaNaloga/materijal.html
// module id = 608
// module chunks = 0